import { NavMenuItem } from '../interfaces';
import { USER_PERMISSIONS } from './user-permissions';
import { USER_VISIBILITY_PERMISSIONS } from './user-visibility-permissions';

export const APP_MENU_MAP: { [appId: string]: NavMenuItem[] } = {
  amministrazione: [
    {
      href: '/amministrazione',
      title: 'Dashboard',
      active: false,
      icon: 'home',
      areHomePage: true,
    },
    // --- GRUPPO 1: STRUTTURA ORGANIZZATIVA TERRITORIALE ---
    {
      title: 'Struttura organizzativa territoriale',
      svgIcon: 'chart_people',
      description:
        'Una panoramica delle articolazioni operative e degli ambiti geografici che definiscono l’organizzazione territoriale dell’Azienda Sanitaria.',
      imagePath: 'assets/images/struttura.webp',
      active: false,
      permissions: [
        USER_PERMISSIONS.struct_admin,
        USER_PERMISSIONS.contesti_admin,
        USER_PERMISSIONS.moduli_admin,
      ],
      subItems: [
        {
          href: '/amministrazione/lista-strutture',
          title: 'STRUTTURE.title',
          active: false,
          icon: 'apartment',
          permissions: [USER_PERMISSIONS.struct_admin],
        },
        {
          href: '/amministrazione/lista-ambulatori',
          title: 'Ambulatori',
          active: false,
          icon: 'local_hospital',
          permissions: [USER_PERMISSIONS.struct_admin],
        },
        {
          href: '/amministrazione/lista-contesti',
          title: 'CONTESTI.title',
          active: false,
          icon: 'list',
          permissions: [USER_PERMISSIONS.contesti_admin],
        },
        {
          href: '/amministrazione/lista-moduli',
          title: 'MODULI.title',
          active: false,
          icon: 'medical_services',
          permissions: [USER_PERMISSIONS.moduli_admin],
        },
      ],
    },
    // --- GRUPPO 2: GOVERNANCE DEGLI OPERATORI ---
    {
      title: 'Governance degli operatori',
      svgIcon: 'new_job',
      description:
        'Qui puoi gestire in modo chiaro e sicuro i profili degli operatori. La sezione assicura trasparenza e coerenza tra ruoli, funzioni e accessi, garantendo un governo semplice e affidabile delle attività.',
      imagePath: 'assets/images/governance.webp',
      active: false,
      permissions: [
        USER_PERMISSIONS.lavori_admin,
        USER_PERMISSIONS.ruoli_admin,
        USER_PERMISSIONS.san_admin,
      ],
      subItems: [
        {
          href: '/amministrazione/lista-lavori',
          title: 'LAVORI.title',
          active: false,
          icon: 'workspaces',
          permissions: [USER_PERMISSIONS.lavori_admin],
        },
        {
          href: '/amministrazione/lista-ruoli',
          title: 'Ruoli e permessi',
          active: false,
          icon: 'assignment_ind',
          permissions: [USER_PERMISSIONS.ruoli_admin],
        },
        {
          href: '/amministrazione/sanitario',
          title: 'Operatori sanitari',
          active: false,
          icon: 'account_box',
          permissions: [USER_PERMISSIONS.san_admin],
        },
      ],
    },
    // --- GRUPPO 3: CONFIGURAZIONE DEI PROCESSI ED ATTIVITA ---
    {
      title: 'Configurazione dei processi ed attivita',
      svgIcon: 'workflow',
      imagePath: 'assets/images/configurazione.webp',
      description:
        'Gli strumenti per definire e personalizzare i processi operativi. Qui puoi modellare flussi di lavoro, form dinamici e attività assistenziali, adattandoli alle esigenze organizzative e ai diversi contesti.',
      active: false,
      permissions: [
        USER_PERMISSIONS.form_admin,
        USER_PERMISSIONS.prestazioni_admin,
        USER_PERMISSIONS.esiti_admin,
        USER_PERMISSIONS.workflow_admin,
      ],
      subItems: [
        {
          href: '/amministrazione/lista-form',
          title: 'Form dinamici',
          icon: 'list',
          active: false,
          permissions: [USER_PERMISSIONS.form_admin],
        },
        {
          href: '/amministrazione/lista-prestazioni',
          title: 'PRESTAZIONI.title',
          active: false,
          icon: 'build',
          permissions: [USER_PERMISSIONS.prestazioni_admin],
        },
        {
          href: '/amministrazione/lista-esiti',
          title: 'ESITI.title',
          active: false,
          icon: 'check_circle_outline',
          permissions: [USER_PERMISSIONS.esiti_admin],
        },
        {
          href: '/amministrazione/lista-workflow',
          title: 'WORKFLOW.title',
          active: false,
          icon: 'lightbulb',
          permissions: [USER_PERMISSIONS.workflow_admin],
        },
        {
          href: '/amministrazione/lista-workflow-pic',
          title: 'WORKFLOW.title-pic',
          active: false,
          icon: 'lightbulb',
          permissions: [USER_PERMISSIONS.workflow_admin],
        },
        {
          href: '/amministrazione/esami-obiettivi',
          title: 'Esami obiettivi',
          active: false,
          icon: 'add_task',
          permissions: [USER_PERMISSIONS.workflow_admin],
        },
      ],
    },
    // --- GRUPPO 4: ANAGRAFICA E TIPOLOGICHE ---
    {
      title: 'Anagrafica e tipologiche',
      svgIcon: 'registration',
      description:
        'Gli strumenti per gestire in modo semplice e centralizzato le anagrafiche di sistema (pazienti, operatori, strutture ed enti) insieme alle tabelle tipologiche usate come elenchi di riferimento nei diversi moduli.',
      imagePath: 'assets/images/anagrafica_e_tipologica.webp',
      active: false,
      permissions: [
        USER_PERMISSIONS.anag_admin,
        USER_PERMISSIONS.tipologiche_admin,
      ],
      subItems: [
        {
          href: '/amministrazione/anagrafica',
          title: 'ANAGRAFICA.title',
          active: false,
          icon: 'account_box',
          permissions: [USER_PERMISSIONS.anag_admin],
        },
        {
          href: '/amministrazione/tipologiche',
          title: 'TIPOLOGICHE.title',
          active: false,
          icon: 'format_list_numbered',
          permissions: [USER_PERMISSIONS.tipologiche_admin],
        },
      ],
    },
  ],
  home: [
    {
      href: 'nuova-segnalazione',
      title: 'SEGNALAZIONE.nuova_segnalazione',
      active: false,
      isSpecialAction: true,
      specialActionType: 'nuova-segnalazione',
      icon: 'add',
      permissions: [USER_VISIBILITY_PERMISSIONS.btn_create_segnalazioni],
    },
    {
      href: '/home/dashboard',
      title: 'Home page',
      active: false,
      icon: 'home',
      homepageForPermission: USER_PERMISSIONS.coordinatore,
      permissions: [USER_PERMISSIONS.coordinatore],
    },
    {
      href: '/home/calendario',
      title: 'MENU.calendar',
      active: false,
      icon: 'calendar_month',
      areHomePage: false,
      homepageForPermission: USER_PERMISSIONS.operativo,
      permissions: [USER_PERMISSIONS.coordinatore, USER_PERMISSIONS.operativo],
    },
    {
      href: '/home/struttura',
      title: 'SANITARIO.pazienti_in_carico',
      active: false,
      icon: ' apartment',
      permissions: [USER_VISIBILITY_PERMISSIONS.btn_vediStruttura],
    },
    {
      href: '/home/presenze',
      title: 'PRESENZE.plural',
      active: false,
      icon: ' checklist',
      permissions: [USER_VISIBILITY_PERMISSIONS.btn_create_presenze],
    },
    {
      href: '/home/organigramma/:strutturaId',
      title: 'ORGANIGRAMMA.title',
      active: false,
      icon: 'hub',
      permissions: [USER_PERMISSIONS.organigramma],
    },
    {
      href: '/home/sanitario/:strutturaId',
      title: 'SANITARIO.title',
      active: false,
      icon: 'medical_services',
      permissions: [USER_PERMISSIONS.sanitario_admin_struttura],
    },
  ],
};
